var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shown ? _c('div', {
    staticClass: "s-modal",
    class: {
      'g-modal-no-actions': _vm.noActions
    }
  }, [_c('div', {
    staticClass: "s-modal-backdrop"
  }), _c('div', {
    staticClass: "s-modal-panel"
  }, [_c('div', {
    staticClass: "s-modal-header",
    class: {
      's-modal-header--has-bottom': _vm.hasHeader
    }
  }, [_vm.hasHeader ? _c('span', {
    staticClass: "modal-header-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('i', {
    staticClass: "s-modal-close-icon",
    on: {
      "click": _vm.close
    }
  })]), _c('div', {
    staticClass: "s-modal-body"
  }, [_vm._t("default")], 2), !_vm.noActions ? _c('div', {
    staticClass: "s-modal-actions"
  }, [_vm._t("actions", function () {
    return [_c('button', {
      staticClass: "s-btn s-btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.close
      }
    }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")])];
  }, {
    "close": _vm.close
  })], 2) : _vm._e()])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }